import React, { useEffect, useState } from "react";
import Reviews from "../../pages/Reviews";
import { IReviewsList } from "../../../types/global";
import ReviewCard from "../../cards/ReviewCard";
import ReviewService from "../../../services/Review.service";

const FeedbackFromClients = ({ className }: { className?: string }) => {
  const [reviewData, setReviewData] = useState<IReviewsList[]>([]);

  const fetchReviews = async () => {
    try {
      const res = await ReviewService.fetchReviews("");
      setReviewData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);
  return (
    <div className={`bg-gray-200 ${className}`}>
      <div className="container mx-auto px-4 lg:px-8  py-20">
        <section className="">
          <div className="prose">
            <h1>What hikers say about us ?</h1>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            {/* <Reviews /> */}
            {reviewData.map((item, i) => (
              <ReviewCard
                key={i}
                reviewType={item.review_category.review_category_name}
                data={{
                  reviewHighlight: item.review_headline,
                  img: item.user_img,
                  location: item.address,
                  name: item.name,
                  review: item.message,
                  stars: item.rating,
                }}
                reviewRef={null}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default FeedbackFromClients;
